var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AddIcon from "@mui/icons-material/Add";
import { Button, Stack, Typography } from "@mui/material";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { convertLocalDateToDate, formatFullDate } from "../../../utils/date.util";
import { getStayStatusDisplay } from "../../uiElements/StayStatusElement";
import ProfileAvatar from "../../profileIdentity/ProfileAvatar";
import { getDisplayName } from "../../profileIdentity/profileIdentity.util";
import { getBoardLabel } from "../stayDisplay";
export var useStayLine = function () {
    var t = useTranslation().t;
    return function (status, stay) {
        var display = getStayStatusDisplay(status);
        if (!display || !stay)
            return undefined;
        var start = convertLocalDateToDate(stay.startDay);
        var when = status === 'UPCOMING' && start
            ? " ".concat(DateTime.fromJSDate(start).toFormat(DateTime.fromJSDate(start).year === DateTime.now().year ? 'dd.MM' : 'dd.MM.yyyy'))
            : '';
        return [
            stay.roomId && "".concat(t('Room'), " ").concat(stay.roomId),
            getBoardLabel(stay),
            "".concat(t(display.label)).concat(when)
        ].filter(Boolean).join(' · ');
    };
};
export var useGuestLine = function () {
    var t = useTranslation().t;
    var stayLine = useStayLine();
    return function (_a) {
        var _b;
        var status = _a.status, stay = _a.stay, lastStay = _a.lastStay, birthDay = _a.birthDay, email = _a.email;
        var last = convertLocalDateToDate(lastStay);
        return (_b = stayLine(status, stay)) !== null && _b !== void 0 ? _b : [
            last && "".concat(t('Last stay'), " ").concat(DateTime.fromJSDate(last).toFormat('MM.yyyy')),
            birthDay && formatFullDate(convertLocalDateToDate(birthDay)),
            email
        ].filter(Boolean).join(' · ');
    };
};
export var RowButton = function (_a) {
    var onClick = _a.onClick, disabled = _a.disabled, _b = _a.divider, divider = _b === void 0 ? true : _b, children = _a.children;
    return (_jsx(Stack, __assign({ direction: 'row', alignItems: 'center', gap: '12px', role: 'button', tabIndex: disabled ? -1 : 0, "aria-disabled": disabled, onClick: disabled ? undefined : onClick, onKeyDown: function (event) {
            if (!disabled && (event.key === 'Enter' || event.key === ' ')) {
                event.preventDefault();
                onClick();
            }
        }, sx: {
            py: '8px',
            px: '6px',
            mx: '-6px',
            borderBottom: divider ? '1px solid' : 'none',
            borderColor: 'divider',
            cursor: disabled ? 'default' : 'pointer',
            '&:hover': disabled ? undefined : { bgcolor: 'rgba(15, 23, 42, 0.04)' }
        } }, { children: children })));
};
export var RowText = function (_a) {
    var title = _a.title, line = _a.line, titleColor = _a.titleColor;
    return (_jsxs(Stack, __assign({ sx: { flex: 1, minWidth: 0, gap: '2px' } }, { children: [_jsx(Typography, __assign({ noWrap: true, sx: { fontSize: 16, fontWeight: 500 }, color: titleColor }, { children: title })), line && (_jsx(Typography, __assign({ noWrap: true, variant: 'body2', color: 'text.secondary' }, { children: line })))] })));
};
export var GuestRow = function (_a) {
    var profile = _a.profile, completedStays = _a.completedStays, line = _a.line, onClick = _a.onClick, action = _a.action, disabled = _a.disabled, divider = _a.divider;
    return (_jsxs(RowButton, __assign({ onClick: onClick, disabled: disabled, divider: divider }, { children: [_jsx(ProfileAvatar, { profile: profile, completedStays: completedStays }), _jsx(RowText, { title: getDisplayName(profile), line: line }), action] })));
};
export var GuestActionButton = function (_a) {
    var children = _a.children, onClick = _a.onClick;
    return (_jsx(Button, __assign({ startIcon: _jsx(AddIcon, { sx: { fontSize: '18px !important' } }), onClick: onClick, sx: { alignSelf: 'flex-start', height: 40, px: 1, ml: '-8px', fontSize: 15, fontWeight: 600, textTransform: 'none' } }, { children: children })));
};
